import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./component/Home";
import Log from "./component/Log";
import MovieDetails from "./component/MovieDetails";
import Signup from "./component/Signup";
function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/Sign" element={<Signup />} />
          <Route path="/Log" element={<Log />} />
          <Route path="/details/:type/:id" element={<MovieDetails />} />
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
